import React from 'react'
import styled from 'styled-components'
import Card from './Card'
import { InnerLayout } from './Layout'
import check from '../../Assets/img/check.svg';
import checkDisabled from '../../Assets/img/check-disabled.svg';
import DetailCard from './DetailCard';
import { Container } from "react-bootstrap";
import Particle from "../Particle";

import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";

const AppropTechCard = () => {

  const navigate = useNavigate(); // Initialize navigate

  const handleClick = () => {
    navigate("/courses"); // This will navigate to the "/another-page" route
  };
    
    return (
        <Container >
      <ParticleWrapper>
                <Particle />
            </ParticleWrapper>
      <PaymentStyled id='pricing'>
         <InnerLayout>
            <div data-aos='fade-down-right'>
            <h3 className="small-heading">
            Appropriate Technology Development Course
               </h3>
               <p className="c-para">Rethinking How We Create Technology </p>
               <p>The Appropriate Technology Development Course is a self-paced program designed for youth and adults ages 14 and above. This course helps participants shift from being passive users of technology to becoming thoughtful developers who shape technology with purpose, ethics, and community needs in mind. It also supports current tech developers in expanding their capacity to offer meaningful technical assistance to their communities.</p>
               <p>Why This Course Matters</p>
               <p>Technology is never neutral. From the industrial revolution to the digital age, innovations have expanded human capacity while reshaping society and with that comes responsibility. Too often, new tools are adopted without regard for their social, ethical, or environmental consequences. This course asks learners to pause, reflect, and design technologies that align with human values, foster justice, and advance the common good.</p>
            </div>
            <Button onClick={handleClick}>View Trainings</Button>
            <div className='card-con'>
               <Card
                  account={'What You’ll Learn'}                 
                  text={'Whether you’re just beginning your tech journey or already a developer looking to deepen your ethical framework, this training will equip you to build technologies that serve humanity and foster vibrant communities.'}
                  button={'Register Here'}               
                  link="https://docs.google.com/forms/d/e/1FAIpQLSfyUZt4peUyGezMs72Taa9NH0s-IayV7VJpHF8kV7YQbZ1tpg/viewform"
                //   active={active}
                //   inactive={inactive}
                  check={check}
                  checkDis={checkDisabled}
                  text1={'Reading Reality Before Designing Solutions: Study social structures, forces, and conditions that shape lives. Identify challenges through the lens of the community itself. Build capacity so people become active participants, not passive consumers.  '}
                  text2={'Ethical Tools for Design: (Reflect on benefits) Who truly gains from this technology? Identify risks to individuals, communities, and ecosystems. Engage diverse stakeholders to reduce bias and blind spots. Anticipate misuse and design safeguards to prevent harm.'}
                  text3={'Hands-On Application: Develop working methodologies and conceptual frameworks for creating appropriate systems of tech development. Design and apply ethical tools in software engineering and workflow design. Incorporate lessons from other communities facing similar challenges. Envision people as resources for social change, not just users of tools. Explore alternative systems of tech development tailored to your region.'}
                  text4={'Community-Centered Development: Engage community members as co-creators throughout the design process. Prioritize local knowledge, values, and needs over external assumptions. Build trust through transparency, accountability, and ongoing dialogue. Ensure technologies are accessible, affordable, and sustainable for the communities they serve.'}
                  text5={'Lifelong Learning: Technology and society are constantly evolving. Cultivate a mindset of continuous learning, reflection, and adaptation. Stay informed about emerging trends, ethical debates, and best practices in tech development. Seek feedback from communities and peers to improve your work over time.'}                  
                  text6={'Collaboration & Networking: Join a community of like-minded individuals committed to ethical tech development. Share resources, insights, and opportunities for collaboration. Learn from diverse perspectives and experiences to enrich your understanding and approach.'}
               />

               <Card
                  account={'Payment'}
                  amount={'$99.99'}
                  text={'A seamless and user-friendly payment integration.'}
                button={'Pay Here'}
                link="https://checkout.square.site/merchant/MLAY6G9T625V1/checkout/VCRFVWRPBTXRFGMAMKK34RNV"                
                //   active={active}
                //   inactive={inactive}
                  check={check}                 
                  text1={'Course Length: 10 hours.'}
                  text2={'Experience: No experience needed. A desire to understand how technology impacts society and to design solutions with purpose.'}
                  text3={'Certification: Certificate awarded upon completion.'}
                  text4={'Course Setting: Remote.'}
                  text5={'Software Requirements: No paid software required.'}
                  text6={'Course Requirements: Access to a computer and internet. Openness to learning from diverse perspectives, engaging in ethical reflection, and considering the broader social and environmental impact of technology.'}
                  
                 />

           </div>
         </InnerLayout>
            </PaymentStyled>
            <Container>
                <DetailCard/>
                </Container>
            </Container>
      
   )
}

const ParticleWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;  // Place it behind all other content
`;

const PaymentStyled = styled.section`
 .card-con {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 2rem; /* Reduce the gap between the cards */
    padding-top: 4rem; /* Reduce top padding */
    
    /* Optional: Use max-width to control the card's maximum size */
    max-width: 1200px;
    margin: 0 auto;
        
    @media screen and (max-width: 689px) {
      grid-template-columns: 1fr; /* Stack cards on mobile */
    }
  }

  p {
    text-align: center;
  }
`



export default AppropTechCard
